import React, {Component} from 'react';
import {Modal, Button, Row, Col}  from 'react-bootstrap'
import MeterDropdown from './MeterDropdown';

import '../report-header.css'
import './massedit.css'

export default class MassEdit extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      errMsg: null,
      changedInputs: [],
    }
    this.show = props.show;
    this.handleClose = this.handleClose.bind(this);
    this.validate = this.validate.bind(this);
  }

  handleClose() {
    this.show = false;
    this.props.hide();
  }

  handleChange = event => {
    const stateData = {property:event.target.id, value: event.target.value}
    let temp = this.state.changedInputs.slice(0);
    const changedIndex = temp.findIndex(item => item.property === event.target.id)
    changedIndex >= 0 ? temp[changedIndex] = stateData : temp.push(stateData);
    this.setState({changedInputs: temp})
  }
  
  validate() {
    var msg = null;
    // validation here?
    if (msg === null) {
      this.handleClose();
    }
    if (this.props.onChange)
      this.props.onChange(this.state);
  }

  render() {
    const msg = this.props.count === 0 ? "Check some boxes to mass edit those devices" : this.state.errMsg;
    return(
      <Modal show={this.props.show} onHide={this.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Mass Edit</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <Row className='mt-4'>
          <Col md="3" className="label-item">Building</Col>
          <Col><input className="input-item" type="text" id="building" onChange={this.handleChange}/></Col>
        </Row>
        <Row className='mt-4'>
          <Col md="3" className="label-item">Meter Model</Col>
          <Col><MeterDropdown anchorStyle="dialog-anchor"/></Col>
        </Row>
        <Row className='mt-4'>
          <Col md="3" className="label-item">Units</Col>
          <Col><input className="input-item" type="text" id="sensors.0.units" onChange={this.handleChange}/></Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-error">{msg}</div>
        <Button className="custom-btn-cancel" onClick={this.handleClose}>
          Cancel
        </Button>
        <Button className="custom-ok-btn" onClick={this.validate}>
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
    )
  }
}  